import { useEffect, useState } from "react";
import "../index.css";

export function PatientSatisfaction({ surveyData, updateSurvey }) {
    const [satisfactionData, setSatisfactionData] = useState(
        surveyData.satisfaction || {
            rating: "",
            recommendation: ""
        }
    );

    useEffect(() => {
        updateSurvey("satisfaction", satisfactionData);
    }, [satisfactionData]);

    const updateSatisfactionData = (key, value) => {
        setSatisfactionData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    return (
        <div
            className="flex flex-col items-center p-6 bg-white shadow-lg rounded-2xl"
            style={{
                width: "100%",
                height: "450px",
                textAlign: "center",
                paddingTop: "10px",
                boxSizing: "border-box",
            }}
        >
            <h2 className="text-lg font-semibold mb-3">
                Patient Satisfaction Survey
            </h2>

            {/* Target Icon */}
            <div
                className="mb-6"
                style={{
                    fontSize: "64px",
                    lineHeight: 1,
                }}
                aria-hidden="true"
            >
                🎯
            </div>

            {/* Satisfaction rating */}
            <h2 className="text-md font-semibold mb-2">
                How satisfied are you with your experience?
            </h2>

            <div className="flex space-x-3 mb-6">
                {[1, 2, 3, 4, 5].map(num => (
                    <button
                        key={num}
                        onClick={() => updateSatisfactionData("rating", num)}
                        className={`w-45 h-50 rounded-full border 
                            ${satisfactionData.rating === num ? "bg-blue-500 text-white" : "bg-white"}`}
                    >
                        {num}
                    </button>
                ))}
            </div>
        </div>
    );
}

